// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__1Bm7N","rootSuccess":"CompleteLink_rootSuccess__1uc7S","rootFailure":"CompleteLink_rootFailure__2E3wd","isDisabled":"CompleteLink_isDisabled__1_r7S"};